module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-cq9.04c9f39f.png";